(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
      constructor() {
        super()
        const rawDate = this.getAttribute('data-date');
        this.date = new Date(rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/'));
        // this.date = new Date(this.getAttribute('data-date'))
        this.hideClass = this.getAttribute('data-hide-class')
        this.unit = this.getAttribute('data-show-unit')
        this.timer = null
      }
      connectedCallback() {
        this.timer = setInterval(this.updateCountdown.bind(this), 1000);
      }
    
      updateCountdown(){
        const now = new Date();
        const diff = this.date - now;
    
        if (diff <= 0) {
          // this.closest(`.${this.hideClass}`).classList.add('hide')
          this.closest(`.${this.hideClass}`).remove()
          clearInterval(this.timer);
          return;
        }
    
        // 计算天、时、分、秒
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
    
        const daysText = `<span>${days<10?'0'+days:days}</span>`;
        const hoursText = `<span>${hours<10?'0'+hours:hours}</span>`;
        const minutesText = `<span>${minutes<10?'0'+minutes:minutes}</span>`;
        const secondsText = `<span>${seconds<10?'0'+seconds:seconds}</span>`;
    
        // 更新倒计时文本
        const countdownText = `${daysText}:${hoursText}:${minutesText}:${secondsText}`;
    
        this.innerHTML = countdownText;
      }
    }
    if (!window.customElements.get('yg-count-down')) {
      window.customElements.define('yg-count-down', YGCountDown)
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getYGImageLoader) {
          this.getYGImageLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      this.popupTemplate = popupTemplate;
      this.popupClass = popupClass;
      this.closeBtnClass = closeBtnClass;
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-close').classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.querySelector('.yg-popup-box-content-inner').innerHTML = popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        this.querySelector('.yg-popup-box-close').classList.remove(`${closeBtnClass}`)
        this.classList.remove(`${popupClass}`)
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getYGVideoLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('hide');
      this.playVideoButton?.classList.add('hide');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        
        this.videoContainer.classList.remove('hide');
        videos.forEach(video => {
          video.play();
        });

        return;
      }

      this.appendChild(this.template?.content.cloneNode(true));
    }

    pauseVideo() {
      this.image?.classList.remove('hide');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.add('hide');

        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
